/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Component Properties"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "mode"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " defines how the StepIndicator should work. Use ", _jsx(_components.code, {
              children: "static"
            }), " for non-interactive steps. Use ", _jsx(_components.code, {
              children: "strict"
            }), " for a chronological step order, also, the user can navigate between visited steps. Use ", _jsx(_components.code, {
              children: "loose"
            }), " if the user should be able to navigate freely."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "data"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " defines the data/steps showing up in a JavaScript Array or JSON format like ", _jsx(_components.code, {
              children: "[{title,is_current}]"
            }), ". See parameters and the example above."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "sidebar_id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " a unique string-based ID in order to bind together the main component and the sidebar (", _jsx(_components.code, {
              children: "<StepIndicator.Sidebar />"
            }), "). Both have to get the same ID."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "current_step"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the active number marked step starting by 0. Defaults to ", _jsx(_components.code, {
              children: "0"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "overview_title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " The title shown inside the ", _jsx(_components.code, {
              children: "<StepIndicatorModal />"
            }), " supplemental screen reader text for the ", _jsx(_components.code, {
              children: "<StepIndicatorTriggerButton />"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "Steps Overview"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "step_title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Label for ", _jsx(_components.code, {
              children: "<StepIndicatorTriggerButton />"
            }), " and screen reader text for ", _jsx(_components.code, {
              children: "<StepIndicatorItem />"
            }), ". Must contain ", _jsx(_components.code, {
              children: "%step"
            }), " and ", _jsx(_components.code, {
              children: "%count"
            }), " to interpolate ", _jsx(_components.code, {
              children: "current_step"
            }), " and ", _jsx(_components.code, {
              children: "stepCount"
            }), " into the text. Defaults to ", _jsx(_components.code, {
              children: "Step %step of %count"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "step_title_extended"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Descriptive label for ", _jsx(_components.code, {
              children: "<StepIndicatorModal />"
            }), ". Must contain ", _jsx(_components.code, {
              children: "%step"
            }), " and ", _jsx(_components.code, {
              children: "%count"
            }), " to interpolate ", _jsx(_components.code, {
              children: "current_step"
            }), " and ", _jsx(_components.code, {
              children: "stepCount"
            }), " into the text. Defaults to", _jsx(_components.code, {
              children: "You are on step %step of %count"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hide_numbers"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define whether to show automatically counted numbers or not. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "no_animation"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the height animation on the step items and the drawer button will be omitted. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_item_render"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " callback function to manipulate or wrap every item. Has to return a React Node. You receive an object you can use in your custom HOC ", _jsx(_components.code, {
              children: "{ StepItem, element, attributes, props, context }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_click"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Will be called once the user clicks on the current or another step. Will be emitted on every click. Returns an object ", _jsx(_components.code, {
              children: "{ event, item, current_step, currentStep }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_change"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Will be called once the user visits actively a new step. Will be emitted only once. Returns an object ", _jsx(_components.code, {
              children: "{ event, item, current_step, currentStep }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Steps Parameters"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Parameters"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " the title as a string or React element."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "is_current"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", this item step will be set as the current current selected step. This can be used instead of ", _jsx(_components.code, {
              children: "current_step"
            }), " on the component itself."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inactive"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", this item step will be handled as an inactive step and will not be clickable. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "disabled"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", this item step will be visible as an disabled button and will not be clickable. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Is used to set the status text."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " In case the status state should be ", _jsx(_components.code, {
              children: "info"
            }), " or ", _jsx(_components.code, {
              children: "error"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "warn"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_render"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " callback function to manipulate or wrap a certain item. Has to return a React Node. Receives parameters ", _jsx(_components.code, {
              children: "{ StepItem, element, attributes, props, context }"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_click"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " event function that gets invoked once the users clicks on the active item. Receives parameters ", _jsx(_components.code, {
              children: "{ event, item, current_step, currentStep }"
            })]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Steps example"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "const steps = [\n  { title: 'Active' },\n  { title: 'Active and marked as current', is_current: true },\n  { title: 'Not active', inactive: true },\n  { title: 'Disabled', disabled: true },\n  {\n    title: 'Active item with status text',\n    status: 'Status text',\n    status_state: 'warn', // defaults to warning\n  },\n]\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
